document.addEventListener("DOMContentLoaded", function () {
  const cartButton = document.querySelector(".cart-toggle-button");
  const cartOverlay = document.querySelector(".cart-overlay");
  const cartWrapper = document.querySelector(".cart-wrapper");
  const cartCounter = document.querySelector(".cart_counter");

  // Utility to lock/unlock body scroll (currently unused)
  function toggleCartBodyScroll(disable) {
    if (disable) {
      document.body.style.setProperty("overflow", "hidden", "important");
    } else {
      document.body.style.removeProperty("overflow");
    }
  }
  function preventCartScroll(e) {
    e.preventDefault();
  }

  // Display cart when clicked
  cartButton.addEventListener("click", function (e) {
    e.stopPropagation();
    cartOverlay.style.display = "block";

    // Force browser reflow
    void cartOverlay.offsetWidth;

    cartOverlay.classList.add("active");
    cartWrapper.classList.add("active");
    toggleCartBodyScroll(true);
  });

  // Hide cart when clicking outside
  document.addEventListener("click", function (e) {
    // Prevent cart from unlocking scroll if menu is open
    const header = document.querySelector(".header");
    if (header && header.classList.contains("expanded")) {
      return; // Do nothing if menu is open
    }
    if (!cartWrapper.contains(e.target) && !cartButton.contains(e.target)) {
      cartOverlay.classList.remove("active");
      cartWrapper.classList.remove("active");

      toggleCartBodyScroll(false);

      // Hide overlay after fade transition completes
      setTimeout(() => {
        cartOverlay.style.display = "none";
      }, 300);
    }
  });

  // Prevent clicks inside cart from closing it
  cartWrapper.addEventListener("click", function (e) {
    e.stopPropagation();
  });

  // Money Format
  function formatMoney(cents) {
    const currency = window.shopCurrency || "USD";

    if (window.moneyFormat) {
      const amount = cents / 100;

      // Handle various Shopify money format templates
      if (window.moneyFormat.includes("{{amount}}")) {
        return window.moneyFormat.replace("{{amount}}", amount.toFixed(2));
      } else if (window.moneyFormat.includes("{{amount_no_decimals}}")) {
        return window.moneyFormat.replace(
          "{{amount_no_decimals}}",
          Math.round(amount).toString()
        );
      } else if (
        window.moneyFormat.includes("{{amount_with_comma_separator}}")
      ) {
        return window.moneyFormat.replace(
          "{{amount_with_comma_separator}}",
          amount.toFixed(2).replace(".", ",")
        );
      } else if (
        window.moneyFormat.includes("{{amount_with_space_separator}}")
      ) {
        return window.moneyFormat.replace(
          "{{amount_with_space_separator}}",
          amount.toFixed(2).replace(".", " ")
        );
      }
    }

    // Fallback to browser's Intl formatter
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency: currency,
    }).format(cents / 100);
  }

  // Remove Items
  function bindRemoveButtons() {
    const removeButtons = document.querySelectorAll("[data-remove-item]");

    removeButtons.forEach((button) => {
      if (button.hasEventListener) return; // Prevent duplicate listeners

      button.hasEventListener = true;
      button.addEventListener("click", async function (e) {
        e.preventDefault();

        const form = this.closest(".remove-form");
        const itemContainer = this.closest("[data-cart-item]");
        if (!itemContainer || !form) return;

        const itemKey = itemContainer.dataset.cartItem;

        try {
          // Show loading state
          button.disabled = true;
          button.textContent = "Removing...";

          // First get the current cart data to check item quantity
          const currentCart = await (await fetch("/cart.js")).json();

          // Find the current item in the cart
          const cartItem = currentCart.items.find(
            (item) => item.key === itemKey
          );

          if (!cartItem) {
            throw new Error("Item not found in cart");
          }

          // Decrease the quantity by 1 instead of setting to 0
          const newQuantity = Math.max(0, cartItem.quantity - 1);

          const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: newQuantity, // Just decrease by 1
            }),
          });

          const cartData = await response.json();

          // Remove only this item container with animation
          itemContainer.style.opacity = "0";
          itemContainer.style.transition = "opacity 0.3s ease";

          setTimeout(() => {
            // Remove this specific item element
            itemContainer.remove();

            // Update cart count
            cartCounter.innerHTML = `<p>(</p>${cartData.item_count}<p>)</p>`;

            // Update total
            const totalContainer = document.querySelector(
              ".cart-total-container span:last-child"
            );
            if (totalContainer) {
              totalContainer.textContent = formatMoney(cartData.total_price);
            }

            // Hide cart if empty
            if (cartData.item_count === 0) {
              cartOverlay.style.display = "none";
              cartWrapper.classList.remove("active");
            }
          }, 300);
        } catch (error) {
          console.error("Error removing item:", error);
          button.textContent = "Error";
          setTimeout(() => {
            button.disabled = false;
            button.textContent = "Remove";
          }, 1000);
        }
      });
    });
  }
  // Initial binding
  bindRemoveButtons();

  // Re-bind buttons when cart is updated
  const observer = new MutationObserver(bindRemoveButtons);
  observer.observe(document.querySelector(".cart-items-flex-container"), {
    childList: true,
    subtree: true,
  });
});
